import React from "react";

class StaffsCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <React.Fragment>
        <div className="col-sm-3 mt-2">
          <div
            className="card"
            style={{ border: "2px solid rgba(0,0,0,.125)" }}
          >
            <div className="card-body">
              <h5 className="card-title">Name: {this.props.staffName}</h5>
              <p className="card-text">Email: {this.props.staffEmail}</p>
              <p className="card-text">Contact: {this.props.staffContact}</p>
              <p className="card-text">Address: {this.props.staffAddress}</p>
              <p className="card-text">
                Status: {this.props.status ? "Active" : "Inactive"}
              </p>
              <p className="card-text">Admin: {this.props.admin.toString()}</p>
              <button
                href="#"
                className="btn btn-primary m-0 p-0 px-2 mr-2"
                data-toggle="modal"
                data-target={`#${this.props.staffId}`}
                onClick={this.props.setStaffOnEdit}
              >
                Edit
              </button>
              {/* ------------------------------------ Edit Staff Modal starts ------------------------------------*/}
              <div
                className="modal fade"
                id={`${this.props.staffId}`}
                tabIndex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalLabel">
                        Edit and Save the details
                      </h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <form onSubmit={this.props.handleEditSubmit}>
                        <div className="form-group">
                          <label htmlFor="staffName" className="col-form-label">
                            Name:
                          </label>
                          <input
                            name="staffName"
                            type="text"
                            className="form-control"
                            id="staffName"
                            value={this.props.staffName}
                            onChange={(e) =>
                              this.props.handleChange(e, this.props.staffId)
                            }
                            required
                          />
                        </div>
                        {/* <div className="form-group">
                          <label
                            htmlFor="staffEmail"
                            className="col-form-label"
                          >
                            Email:
                          </label>
                          <input
                            name="staffEmail"
                            type="email"
                            className="form-control"
                            id="staffEmail"
                            value={this.props.staffEmail}
                            onChange={(e) =>
                              this.props.handleChange(e, this.props.staffId)
                            }
                            required
                          />
                        </div> */}
                        <div className="form-group">
                          <label
                            htmlFor="staffContact"
                            className="col-form-label"
                          >
                            Contact:
                          </label>
                          <input
                            name="staffContact"
                            type="text"
                            className="form-control"
                            id="staffContact"
                            value={this.props.staffContact}
                            onChange={(e) =>
                              this.props.handleChange(e, this.props.staffId)
                            }
                            required
                          />
                        </div>
                        <div className="form-group">
                          <label
                            htmlFor="staffAddress"
                            className="col-form-label"
                          >
                            Address:
                          </label>
                          <input
                            name="staffAddress"
                            type="text"
                            className="form-control"
                            id="staffAddress"
                            value={this.props.staffAddress}
                            onChange={(e) =>
                              this.props.handleChange(e, this.props.staffId)
                            }
                            required
                          />
                        </div>
                        <div className="form-group">
                          <label className="col-form-label">
                            Admin: &nbsp;
                          </label>
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="admin"
                              id="adminYes"
                              value={true}
                              // checked={this.props.admin}
                              onChange={(e) =>
                                this.props.handleChange(e, this.props.staffId)
                              }
                            />
                            <label
                              className="form-check-label"
                              htmlFor="adminYes"
                            >
                              Yes
                            </label>
                          </div>
                          <div className="form-check form-check-inline">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="admin"
                              id="adminNo"
                              value={false}
                              // checked={!this.props.admin}
                              onChange={(e) =>
                                this.props.handleChange(e, this.props.staffId)
                              }
                            />
                            <label
                              className="form-check-label"
                              htmlFor="adminNo"
                            >
                              No
                            </label>
                          </div>
                        </div>
                        <div className="modal-footer">
                          <button
                            type="submit"
                            className="btn btn-success"
                            disabled={this.props.editStaffLoading}
                          >
                            {this.props.editStaffLoading ? "Saving" : "Save"}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              {/* ------------------------------------ Edit Staff Modal ends ------------------------------------*/}
              <button
                type="button"
                className="btn btn-warning m-0 p-0 px-2 mr-2"
                data-toggle="modal"
                data-target={`#st${this.props.staffId}`}
              >
                {this.props.status ? "Deactivate" : "Activate"}
              </button>
              {/* ------------------------------------ Toggle Staff status Modal starts ------------------------------------*/}
              <div
                className="modal fade"
                id={`st${this.props.staffId}`}
                tabIndex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalLabel">
                        Activate / Deactivate
                      </h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <p>
                        Are you sure you want to change status of staff{" "}
                        <strong>{`${this.props.staffName}`}</strong>?
                      </p>
                    </div>
                    <div className="modal-footer">
                      <button
                        href="#"
                        className="btn btn-warning m-0 p-1 px-2 mr-2"
                        id={this.props.staffId}
                        onClick={(e) =>
                          this.props.handleToggleStaffStatus(
                            e,
                            this.props.staffId,
                            this.props.status
                          )
                        }
                        disabled={this.props.toggleStaffStatusBtnLoading}
                      >
                        {this.props.toggleStaffStatusBtnLoading
                          ? "Saving"
                          : "Change"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {/* ------------------------------------ Toggle Staff status Modal ends ------------------------------------*/}
              <button
                type="button"
                className="btn btn-danger m-0 p-0 px-2 mr-2"
                data-toggle="modal"
                data-target={`#sd${this.props.staffId}`}
              >
                Delete
              </button>
              {/* ------------------------------------ Delete Staff Modal starts ------------------------------------*/}
              <div
                className="modal fade"
                id={`sd${this.props.staffId}`}
                tabIndex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="exampleModalLabel">
                        Irreversible operation
                      </h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <p>
                        Are you sure you want to delete staff{" "}
                        <strong>{`${this.props.staffName}`}</strong>?
                      </p>
                    </div>
                    <div className="modal-footer">
                      <button
                        href="#"
                        id={this.props.staffId}
                        className="btn btn-danger m-0 p-1 px-2"
                        onClick={(e) =>
                          this.props.handleDeleteStaff(e, this.props.staffId)
                        }
                        disabled={this.props.deleteStaffBtnLoading}
                      >
                        {this.props.deleteStaffBtnLoading
                          ? "Deleting"
                          : "Delete"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {/* ------------------------------------ Delete Staff Modal ends ------------------------------------*/}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default StaffsCard;
